<app-home [subtype]="subtype$ | async"></app-home>